import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UILanguageFlag() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Language Flag Icon '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="usage" className="mb-5">
									<h4>{'Usage'}</h4>
									<p>
										{
											' Use the Flag Icon library to display country flags with simple classes. Please read the '
										}
										<a href="https://github.com/lipis/flag-icons" target="_blank" rel="noreferrer">
											{'official flag icon documentation'}
										</a>
										{' for the full list of options. '}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div data-scrollbar="true" data-height="55vh" className="p-3">
												<div className="row small fw-semibold">
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ad fs-2" title="ad" id="ad"></div>
															<div className="ps-2 fw-bold">{'AD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ae fs-2" title="ae" id="ae"></div>
															<div className="ps-2 fw-bold">{'AE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-af fs-2" title="af" id="af"></div>
															<div className="ps-2 fw-bold">{'AF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ag fs-2" title="ag" id="ag"></div>
															<div className="ps-2 fw-bold">{'AG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ai fs-2" title="ai" id="ai"></div>
															<div className="ps-2 fw-bold">{'AU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-al fs-2" title="al" id="al"></div>
															<div className="ps-2 fw-bold">{'AL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-am fs-2" title="am" id="am"></div>
															<div className="ps-2 fw-bold">{'AM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ao fs-2" title="ao" id="ao"></div>
															<div className="ps-2 fw-bold">{'AO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-aq fs-2" title="aq" id="aq"></div>
															<div className="ps-2 fw-bold">{'AQ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ar fs-2" title="ar" id="ar"></div>
															<div className="ps-2 fw-bold">{'AR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-as fs-2" title="as" id="as"></div>
															<div className="ps-2 fw-bold">{'AS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-at fs-2" title="at" id="at"></div>
															<div className="ps-2 fw-bold">{'AT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-au fs-2" title="au" id="au"></div>
															<div className="ps-2 fw-bold">{'AU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-aw fs-2" title="aw" id="aw"></div>
															<div className="ps-2 fw-bold">{'AW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ax fs-2" title="ax" id="ax"></div>
															<div className="ps-2 fw-bold">{'AX'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-az fs-2" title="az" id="az"></div>
															<div className="ps-2 fw-bold">{'AZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ba fs-2" title="ba" id="ba"></div>
															<div className="ps-2 fw-bold">{'BA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bb fs-2" title="bb" id="bb"></div>
															<div className="ps-2 fw-bold">{'BB'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bd fs-2" title="bd" id="bd"></div>
															<div className="ps-2 fw-bold">{'BD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-be fs-2" title="be" id="be"></div>
															<div className="ps-2 fw-bold">{'BE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bf fs-2" title="bf" id="bf"></div>
															<div className="ps-2 fw-bold">{'BF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bg fs-2" title="bg" id="bg"></div>
															<div className="ps-2 fw-bold">{'BG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bh fs-2" title="bh" id="bh"></div>
															<div className="ps-2 fw-bold">{'BH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bi fs-2" title="bi" id="bi"></div>
															<div className="ps-2 fw-bold">{'BI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bj fs-2" title="bj" id="bj"></div>
															<div className="ps-2 fw-bold">{'BJ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bl fs-2" title="bl" id="bl"></div>
															<div className="ps-2 fw-bold">{'BL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bm fs-2" title="bm" id="bm"></div>
															<div className="ps-2 fw-bold">{'BM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bn fs-2" title="bn" id="bn"></div>
															<div className="ps-2 fw-bold">{'BN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bo fs-2" title="bo" id="bo"></div>
															<div className="ps-2 fw-bold">{'BO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bq fs-2" title="bq" id="bq"></div>
															<div className="ps-2 fw-bold">{'BQ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-br fs-2" title="br" id="br"></div>
															<div className="ps-2 fw-bold">{'BR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bs fs-2" title="bs" id="bs"></div>
															<div className="ps-2 fw-bold">{'BS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bt fs-2" title="bt" id="bt"></div>
															<div className="ps-2 fw-bold">{'BT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bv fs-2" title="bv" id="bv"></div>
															<div className="ps-2 fw-bold">{'BV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bw fs-2" title="bw" id="bw"></div>
															<div className="ps-2 fw-bold">{'BW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-by fs-2" title="by" id="by"></div>
															<div className="ps-2 fw-bold">{'BY'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-bz fs-2" title="bz" id="bz"></div>
															<div className="ps-2 fw-bold">{'BZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ca fs-2" title="ca" id="ca"></div>
															<div className="ps-2 fw-bold">{'CA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cc fs-2" title="cc" id="cc"></div>
															<div className="ps-2 fw-bold">{'CC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cd fs-2" title="cd" id="cd"></div>
															<div className="ps-2 fw-bold">{'CD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cf fs-2" title="cf" id="cf"></div>
															<div className="ps-2 fw-bold">{'CF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cg fs-2" title="cg" id="cg"></div>
															<div className="ps-2 fw-bold">{'CG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ch fs-2" title="ch" id="ch"></div>
															<div className="ps-2 fw-bold">{'CH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ci fs-2" title="ci" id="ci"></div>
															<div className="ps-2 fw-bold">{'CI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ck fs-2" title="ck" id="ck"></div>
															<div className="ps-2 fw-bold">{'CK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cl fs-2" title="cl" id="cl"></div>
															<div className="ps-2 fw-bold">{'CL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cm fs-2" title="cm" id="cm"></div>
															<div className="ps-2 fw-bold">{'CM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cn fs-2" title="cn" id="cn"></div>
															<div className="ps-2 fw-bold">{'CN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-co fs-2" title="co" id="co"></div>
															<div className="ps-2 fw-bold">{'CO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cr fs-2" title="cr" id="cr"></div>
															<div className="ps-2 fw-bold">{'CR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cu fs-2" title="cu" id="cu"></div>
															<div className="ps-2 fw-bold">{'CU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cv fs-2" title="cv" id="cv"></div>
															<div className="ps-2 fw-bold">{'CV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cw fs-2" title="cw" id="cw"></div>
															<div className="ps-2 fw-bold">{'CW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cx fs-2" title="cx" id="cx"></div>
															<div className="ps-2 fw-bold">{'CX'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cy fs-2" title="cy" id="cy"></div>
															<div className="ps-2 fw-bold">{'CY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-cz fs-2" title="cz" id="cz"></div>
															<div className="ps-2 fw-bold">{'CZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-de fs-2" title="de" id="de"></div>
															<div className="ps-2 fw-bold">{'DE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-dj fs-2" title="dj" id="dj"></div>
															<div className="ps-2 fw-bold">{'DJ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-dk fs-2" title="dk" id="dk"></div>
															<div className="ps-2 fw-bold">{'DK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-dm fs-2" title="dm" id="dm"></div>
															<div className="ps-2 fw-bold">{'DM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-do fs-2" title="do" id="do"></div>
															<div className="ps-2 fw-bold">{'DO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-dz fs-2" title="dz" id="dz"></div>
															<div className="ps-2 fw-bold">{'DZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ec fs-2" title="ec" id="ec"></div>
															<div className="ps-2 fw-bold">{'EC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ee fs-2" title="ee" id="ee"></div>
															<div className="ps-2 fw-bold">{'EE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-eg fs-2" title="eg" id="eg"></div>
															<div className="ps-2 fw-bold">{'EG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-eh fs-2" title="eh" id="eh"></div>
															<div className="ps-2 fw-bold">{'EH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-er fs-2" title="er" id="er"></div>
															<div className="ps-2 fw-bold">{'ER'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-es fs-2" title="es" id="es"></div>
															<div className="ps-2 fw-bold">{'ES'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-et fs-2" title="et" id="et"></div>
															<div className="ps-2 fw-bold">{'ET'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fi fs-2" title="fi" id="fi"></div>
															<div className="ps-2 fw-bold">{'FI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fj fs-2" title="fj" id="fj"></div>
															<div className="ps-2 fw-bold">{'FJ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fk fs-2" title="fk" id="fk"></div>
															<div className="ps-2 fw-bold">{'FK'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fm fs-2" title="fm" id="fm"></div>
															<div className="ps-2 fw-bold">{'FM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fo fs-2" title="fo" id="fo"></div>
															<div className="ps-2 fw-bold">{'FO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-fr fs-2" title="fr" id="fr"></div>
															<div className="ps-2 fw-bold">{'FR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ga fs-2" title="ga" id="ga"></div>
															<div className="ps-2 fw-bold">{'GA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gb fs-2" title="gb" id="gb"></div>
															<div className="ps-2 fw-bold">{'GB'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gd fs-2" title="gd" id="gd"></div>
															<div className="ps-2 fw-bold">{'GD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ge fs-2" title="ge" id="ge"></div>
															<div className="ps-2 fw-bold">{'GE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gf fs-2" title="gf" id="gf"></div>
															<div className="ps-2 fw-bold">{'GF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gg fs-2" title="gg" id="gg"></div>
															<div className="ps-2 fw-bold">{'GG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gh fs-2" title="gh" id="gh"></div>
															<div className="ps-2 fw-bold">{'GH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gi fs-2" title="gi" id="gi"></div>
															<div className="ps-2 fw-bold">{'GI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gl fs-2" title="gl" id="gl"></div>
															<div className="ps-2 fw-bold">{'GL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gm fs-2" title="gm" id="gm"></div>
															<div className="ps-2 fw-bold">{'GM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gn fs-2" title="gn" id="gn"></div>
															<div className="ps-2 fw-bold">{'GN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gp fs-2" title="gp" id="gp"></div>
															<div className="ps-2 fw-bold">{'GP'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gq fs-2" title="gq" id="gq"></div>
															<div className="ps-2 fw-bold">{'GQ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gr fs-2" title="gr" id="gr"></div>
															<div className="ps-2 fw-bold">{'GR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gs fs-2" title="gs" id="gs"></div>
															<div className="ps-2 fw-bold">{'GS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gt fs-2" title="gt" id="gt"></div>
															<div className="ps-2 fw-bold">{'GT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gu fs-2" title="gu" id="gu"></div>
															<div className="ps-2 fw-bold">{'GU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gw fs-2" title="gw" id="gw"></div>
															<div className="ps-2 fw-bold">{'GW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-gy fs-2" title="gy" id="gy"></div>
															<div className="ps-2 fw-bold">{'GY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-hk fs-2" title="hk" id="hk"></div>
															<div className="ps-2 fw-bold">{'HK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-hm fs-2" title="hm" id="hm"></div>
															<div className="ps-2 fw-bold">{'HM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-hn fs-2" title="hn" id="hn"></div>
															<div className="ps-2 fw-bold">{'HN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-hr fs-2" title="hr" id="hr"></div>
															<div className="ps-2 fw-bold">{'HR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ht fs-2" title="ht" id="ht"></div>
															<div className="ps-2 fw-bold">{'HT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-hu fs-2" title="hu" id="hu"></div>
															<div className="ps-2 fw-bold">{'HU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-id fs-2" title="id" id="id"></div>
															<div className="ps-2 fw-bold">{'ID'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ie fs-2" title="ie" id="ie"></div>
															<div className="ps-2 fw-bold">{'IE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-il fs-2" title="il" id="il"></div>
															<div className="ps-2 fw-bold">{'IL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-im fs-2" title="im" id="im"></div>
															<div className="ps-2 fw-bold">{'IM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-in fs-2" title="in" id="in"></div>
															<div className="ps-2 fw-bold">{'IN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-io fs-2" title="io" id="io"></div>
															<div className="ps-2 fw-bold">{'IO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-iq fs-2" title="iq" id="iq"></div>
															<div className="ps-2 fw-bold">{'IQ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ir fs-2" title="ir" id="ir"></div>
															<div className="ps-2 fw-bold">{'IR'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-is fs-2" title="is" id="is"></div>
															<div className="ps-2 fw-bold">{'IS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-it fs-2" title="it" id="it"></div>
															<div className="ps-2 fw-bold">{'IT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-je fs-2" title="je" id="je"></div>
															<div className="ps-2 fw-bold">{'JE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-jm fs-2" title="jm" id="jm"></div>
															<div className="ps-2 fw-bold">{'JM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-jo fs-2" title="jo" id="jo"></div>
															<div className="ps-2 fw-bold">{'JO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-jp fs-2" title="jp" id="jp"></div>
															<div className="ps-2 fw-bold">{'JP'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ke fs-2" title="ke" id="ke"></div>
															<div className="ps-2 fw-bold">{'KE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kg fs-2" title="kg" id="kg"></div>
															<div className="ps-2 fw-bold">{'KG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kh fs-2" title="kh" id="kh"></div>
															<div className="ps-2 fw-bold">{'KH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ki fs-2" title="ki" id="ki"></div>
															<div className="ps-2 fw-bold">{'KI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-km fs-2" title="km" id="km"></div>
															<div className="ps-2 fw-bold">{'KM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kn fs-2" title="kn" id="kn"></div>
															<div className="ps-2 fw-bold">{'KN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kp fs-2" title="kp" id="kp"></div>
															<div className="ps-2 fw-bold">{'KP'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kr fs-2" title="kr" id="kr"></div>
															<div className="ps-2 fw-bold">{'KR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kw fs-2" title="kw" id="kw"></div>
															<div className="ps-2 fw-bold">{'KW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ky fs-2" title="ky" id="ky"></div>
															<div className="ps-2 fw-bold">{'KY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-kz fs-2" title="kz" id="kz"></div>
															<div className="ps-2 fw-bold">{'KZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-la fs-2" title="la" id="la"></div>
															<div className="ps-2 fw-bold">{'LA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lb fs-2" title="lb" id="lb"></div>
															<div className="ps-2 fw-bold">{'LB'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lc fs-2" title="lc" id="lc"></div>
															<div className="ps-2 fw-bold">{'LC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-li fs-2" title="li" id="li"></div>
															<div className="ps-2 fw-bold">{'LI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lk fs-2" title="lk" id="lk"></div>
															<div className="ps-2 fw-bold">{'LK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lr fs-2" title="lr" id="lr"></div>
															<div className="ps-2 fw-bold">{'LR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ls fs-2" title="ls" id="ls"></div>
															<div className="ps-2 fw-bold">{'LS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lt fs-2" title="lt" id="lt"></div>
															<div className="ps-2 fw-bold">{'LT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lu fs-2" title="lu" id="lu"></div>
															<div className="ps-2 fw-bold">{'LU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-lv fs-2" title="lv" id="lv"></div>
															<div className="ps-2 fw-bold">{'LV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ly fs-2" title="ly" id="ly"></div>
															<div className="ps-2 fw-bold">{'LY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ma fs-2" title="ma" id="ma"></div>
															<div className="ps-2 fw-bold">{'MA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mc fs-2" title="mc" id="mc"></div>
															<div className="ps-2 fw-bold">{'MC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-md fs-2" title="md" id="md"></div>
															<div className="ps-2 fw-bold">{'MD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-me fs-2" title="me" id="me"></div>
															<div className="ps-2 fw-bold">{'ME'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mf fs-2" title="mf" id="mf"></div>
															<div className="ps-2 fw-bold">{'MF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mg fs-2" title="mg" id="mg"></div>
															<div className="ps-2 fw-bold">{'MG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mh fs-2" title="mh" id="mh"></div>
															<div className="ps-2 fw-bold">{'MH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mk fs-2" title="mk" id="mk"></div>
															<div className="ps-2 fw-bold">{'MK'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ml fs-2" title="ml" id="ml"></div>
															<div className="ps-2 fw-bold">{'ML'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mm fs-2" title="mm" id="mm"></div>
															<div className="ps-2 fw-bold">{'MM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mn fs-2" title="mn" id="mn"></div>
															<div className="ps-2 fw-bold">{'MN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mo fs-2" title="mo" id="mo"></div>
															<div className="ps-2 fw-bold">{'MO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mp fs-2" title="mp" id="mp"></div>
															<div className="ps-2 fw-bold">{'MP'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mq fs-2" title="mq" id="mq"></div>
															<div className="ps-2 fw-bold">{'MQ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mr fs-2" title="mr" id="mr"></div>
															<div className="ps-2 fw-bold">{'MR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ms fs-2" title="ms" id="ms"></div>
															<div className="ps-2 fw-bold">{'MS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mt fs-2" title="mt" id="mt"></div>
															<div className="ps-2 fw-bold">{'MT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mu fs-2" title="mu" id="mu"></div>
															<div className="ps-2 fw-bold">{'MU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mv fs-2" title="mv" id="mv"></div>
															<div className="ps-2 fw-bold">{'MV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mw fs-2" title="mw" id="mw"></div>
															<div className="ps-2 fw-bold">{'MW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mx fs-2" title="mx" id="mx"></div>
															<div className="ps-2 fw-bold">{'MX'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-my fs-2" title="my" id="my"></div>
															<div className="ps-2 fw-bold">{'MY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-mz fs-2" title="mz" id="mz"></div>
															<div className="ps-2 fw-bold">{'MZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-na fs-2" title="na" id="na"></div>
															<div className="ps-2 fw-bold">{'NA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nc fs-2" title="nc" id="nc"></div>
															<div className="ps-2 fw-bold">{'NC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ne fs-2" title="ne" id="ne"></div>
															<div className="ps-2 fw-bold">{'NE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nf fs-2" title="nf" id="nf"></div>
															<div className="ps-2 fw-bold">{'NF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ng fs-2" title="ng" id="ng"></div>
															<div className="ps-2 fw-bold">{'NG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ni fs-2" title="ni" id="ni"></div>
															<div className="ps-2 fw-bold">{'NI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nl fs-2" title="nl" id="nl"></div>
															<div className="ps-2 fw-bold">{'NL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-no fs-2" title="no" id="no"></div>
															<div className="ps-2 fw-bold">{'NO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-np fs-2" title="np" id="np"></div>
															<div className="ps-2 fw-bold">{'NP'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nr fs-2" title="nr" id="nr"></div>
															<div className="ps-2 fw-bold">{'NR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nu fs-2" title="nu" id="nu"></div>
															<div className="ps-2 fw-bold">{'NU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-nz fs-2" title="nz" id="nz"></div>
															<div className="ps-2 fw-bold">{'NZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-om fs-2" title="om" id="om"></div>
															<div className="ps-2 fw-bold">{'OM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pa fs-2" title="pa" id="pa"></div>
															<div className="ps-2 fw-bold">{'PA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pe fs-2" title="pe" id="pe"></div>
															<div className="ps-2 fw-bold">{'PE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pf fs-2" title="pf" id="pf"></div>
															<div className="ps-2 fw-bold">{'PF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pg fs-2" title="pg" id="pg"></div>
															<div className="ps-2 fw-bold">{'PG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ph fs-2" title="ph" id="ph"></div>
															<div className="ps-2 fw-bold">{'PH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pk fs-2" title="pk" id="pk"></div>
															<div className="ps-2 fw-bold">{'PK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pl fs-2" title="pl" id="pl"></div>
															<div className="ps-2 fw-bold">{'PL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pm fs-2" title="pm" id="pm"></div>
															<div className="ps-2 fw-bold">{'PM'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pn fs-2" title="pn" id="pn"></div>
															<div className="ps-2 fw-bold">{'PN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pr fs-2" title="pr" id="pr"></div>
															<div className="ps-2 fw-bold">{'PR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ps fs-2" title="ps" id="ps"></div>
															<div className="ps-2 fw-bold">{'PS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pt fs-2" title="pt" id="pt"></div>
															<div className="ps-2 fw-bold">{'PT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-pw fs-2" title="pw" id="pw"></div>
															<div className="ps-2 fw-bold">{'PW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-py fs-2" title="py" id="py"></div>
															<div className="ps-2 fw-bold">{'PY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-qa fs-2" title="qa" id="qa"></div>
															<div className="ps-2 fw-bold">{'QA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-re fs-2" title="re" id="re"></div>
															<div className="ps-2 fw-bold">{'RE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ro fs-2" title="ro" id="ro"></div>
															<div className="ps-2 fw-bold">{'RO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-rs fs-2" title="rs" id="rs"></div>
															<div className="ps-2 fw-bold">{'RS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ru fs-2" title="ru" id="ru"></div>
															<div className="ps-2 fw-bold">{'RU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-rw fs-2" title="rw" id="rw"></div>
															<div className="ps-2 fw-bold">{'RW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sa fs-2" title="sa" id="sa"></div>
															<div className="ps-2 fw-bold">{'SA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sb fs-2" title="sb" id="sb"></div>
															<div className="ps-2 fw-bold">{'SB'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sc fs-2" title="sc" id="sc"></div>
															<div className="ps-2 fw-bold">{'SC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sd fs-2" title="sd" id="sd"></div>
															<div className="ps-2 fw-bold">{'SD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-se fs-2" title="se" id="se"></div>
															<div className="ps-2 fw-bold">{'SE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sg fs-2" title="sg" id="sg"></div>
															<div className="ps-2 fw-bold">{'SG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sh fs-2" title="sh" id="sh"></div>
															<div className="ps-2 fw-bold">{'SH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-si fs-2" title="si" id="si"></div>
															<div className="ps-2 fw-bold">{'SI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sj fs-2" title="sj" id="sj"></div>
															<div className="ps-2 fw-bold">{'SJ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sk fs-2" title="sk" id="sk"></div>
															<div className="ps-2 fw-bold">{'SK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sl fs-2" title="sl" id="sl"></div>
															<div className="ps-2 fw-bold">{'SL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sm fs-2" title="sm" id="sm"></div>
															<div className="ps-2 fw-bold">{'SM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sn fs-2" title="sn" id="sn"></div>
															<div className="ps-2 fw-bold">{'SN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-so fs-2" title="so" id="so"></div>
															<div className="ps-2 fw-bold">{'SO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sr fs-2" title="sr" id="sr"></div>
															<div className="ps-2 fw-bold">{'SR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ss fs-2" title="ss" id="ss"></div>
															<div className="ps-2 fw-bold">{'SS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-st fs-2" title="st" id="st"></div>
															<div className="ps-2 fw-bold">{'ST'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sv fs-2" title="sv" id="sv"></div>
															<div className="ps-2 fw-bold">{'SV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sx fs-2" title="sx" id="sx"></div>
															<div className="ps-2 fw-bold">{'SX'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sy fs-2" title="sy" id="sy"></div>
															<div className="ps-2 fw-bold">{'SY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-sz fs-2" title="sz" id="sz"></div>
															<div className="ps-2 fw-bold">{'SZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tc fs-2" title="tc" id="tc"></div>
															<div className="ps-2 fw-bold">{'TC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-td fs-2" title="td" id="td"></div>
															<div className="ps-2 fw-bold">{'TD'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tf fs-2" title="tf" id="tf"></div>
															<div className="ps-2 fw-bold">{'TF'}</div>
														</div>
													</div>
													<div className="col-lg col-md-3 col-6">
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tg fs-2" title="tg" id="tg"></div>
															<div className="ps-2 fw-bold">{'TG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-th fs-2" title="th" id="th"></div>
															<div className="ps-2 fw-bold">{'TH'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tj fs-2" title="tj" id="tj"></div>
															<div className="ps-2 fw-bold">{'TJ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tk fs-2" title="tk" id="tk"></div>
															<div className="ps-2 fw-bold">{'TK'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tl fs-2" title="tl" id="tl"></div>
															<div className="ps-2 fw-bold">{'TL'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tm fs-2" title="tm" id="tm"></div>
															<div className="ps-2 fw-bold">{'TM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tn fs-2" title="tn" id="tn"></div>
															<div className="ps-2 fw-bold">{'TN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-to fs-2" title="to" id="to"></div>
															<div className="ps-2 fw-bold">{'TO'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tr fs-2" title="tr" id="tr"></div>
															<div className="ps-2 fw-bold">{'TR'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tt fs-2" title="tt" id="tt"></div>
															<div className="ps-2 fw-bold">{'TT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tv fs-2" title="tv" id="tv"></div>
															<div className="ps-2 fw-bold">{'TV'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tw fs-2" title="tw" id="tw"></div>
															<div className="ps-2 fw-bold">{'TW'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-tz fs-2" title="tz" id="tz"></div>
															<div className="ps-2 fw-bold">{'TZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ua fs-2" title="ua" id="ua"></div>
															<div className="ps-2 fw-bold">{'UA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ug fs-2" title="ug" id="ug"></div>
															<div className="ps-2 fw-bold">{'UG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-um fs-2" title="um" id="um"></div>
															<div className="ps-2 fw-bold">{'UM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-us fs-2" title="us" id="us"></div>
															<div className="ps-2 fw-bold">{'US'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-uy fs-2" title="uy" id="uy"></div>
															<div className="ps-2 fw-bold">{'UY'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-uz fs-2" title="uz" id="uz"></div>
															<div className="ps-2 fw-bold">{'UZ'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-va fs-2" title="va" id="va"></div>
															<div className="ps-2 fw-bold">{'VA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-vc fs-2" title="vc" id="vc"></div>
															<div className="ps-2 fw-bold">{'VC'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ve fs-2" title="ve" id="ve"></div>
															<div className="ps-2 fw-bold">{'VE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-vg fs-2" title="vg" id="vg"></div>
															<div className="ps-2 fw-bold">{'VG'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-vi fs-2" title="vi" id="vi"></div>
															<div className="ps-2 fw-bold">{'VI'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-vn fs-2" title="vn" id="vn"></div>
															<div className="ps-2 fw-bold">{'VN'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-vu fs-2" title="vu" id="vu"></div>
															<div className="ps-2 fw-bold">{'VU'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-wf fs-2" title="wf" id="wf"></div>
															<div className="ps-2 fw-bold">{'WF'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ws fs-2" title="ws" id="ws"></div>
															<div className="ps-2 fw-bold">{'WS'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-ye fs-2" title="ye" id="ye"></div>
															<div className="ps-2 fw-bold">{'YE'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-yt fs-2" title="yt" id="yt"></div>
															<div className="ps-2 fw-bold">{'YT'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-za fs-2" title="za" id="za"></div>
															<div className="ps-2 fw-bold">{'ZA'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-zm fs-2" title="zm" id="zm"></div>
															<div className="ps-2 fw-bold">{'ZM'}</div>
														</div>
														<div className="mb-2 d-flex align-items-center">
															<div className="fi fi-zw fs-2" title="zw" id="zw"></div>
															<div className="ps-2 fw-bold">{'ZW'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-language-flag-icon/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#usage" data-toggle="scroll-to">
											{'Usage'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UILanguageFlag;
